import React from 'react';
import { IMAGES_REPO } from '../../../config';

const ComponentView = (props) => {
  const { isSelected, title, body, image, link } = props;
  return (
    <div className={isSelected ? 'notice-view notice-view--selected' : 'notice-view'}>
      <h2>{title}</h2>
      <div className="notice-view__image-container">
        <img src={IMAGES_REPO + '' + image}/>
      </div>
      <span>{link}</span>
      <div className="notice-view__text" dangerouslySetInnerHTML={{ __html: body }}></div>
    </div>
  );
};

export default ComponentView



// WEBPACK FOOTER //
// ./src/components/ListEntity/Entities/Article.js